/**
 * 线下培训班级学员列表功能
 * @Author:wuTao
 * @Date 2020/3/6
 */
import React from 'react';
import {connect} from 'dva';
import {reduxTemplateConfig, templateConfig} from './config';

import {reduxTemplateConfigPerson, templateConfigPerson} from './configPerson';

import {component_tool, framework_tool, utils_tool} from '@/tool'

let {checkStrLength,Session} = utils_tool;
let { WizSpin, WizBrowserExport,WizTabs} = component_tool;
let {WizContainer, WizReduxTemplate, modelUtils} = framework_tool;
import { WizCard } from 'wiz-components/lib';
import ExamInfo  from './../examInfo';
let { TabPane } = WizTabs

class ErrorQuestionAnalysisList extends WizContainer {

  componentName = 'errorQuestionAnalysisList';

  constructor(props) {
    super(props);
    const {history} = props;
    this.state = {
      
    };
    this.initialValue = {};
  }

  _componentWillMount() {
    const {history} = this.props;
    if (history.location.record) {
      Session.set('examQuestionInfoNew', history.location.record);
      this.initialValue = history.location.record;
    } else if (Session.get('examQuestionInfoNew')) {
      this.initialValue = Session.get('examQuestionInfoNew') ? Session.get('examQuestionInfoNew') : {};
    }
  }

  _handleAnswerFile(nextProps, nextState, key) {
    let o = nextProps[key]
    let columnDefs = [
      {
        headerName: '',
        width: 30,
        field: 'rowIndex',
        hidden: true,
        suppressMovable: true,
        cellStyle: {
          textAlign: 'center',
          padding: '5px 0',
          color: '#595959',
          backgroundColor: '#f0f0f0',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: '500',
          boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
        },
      },
      {
        headerName: '错误答案',
        field: 'answer',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '答错人数',
        field: 'answerErrorPersonIdCount',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '答错次数',
        field: 'answerErrorTimeCount',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
    ]
    if(o['success']){
      let data = o['data']
      data && data.forEach(d => {
        if (!d.answer || d.answer.length == 0) {
          d.answer = '未作答'
        } 
      })
      WizBrowserExport({
        title: '错误答案分析',
        sheetName: '错误答案分析',
        columns: columnDefs.filter((_, index) => index),
        rows: data,
        filename: '错误答案分析.xlsx'
      })
      return true
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _handlePersonFile(nextProps, nextState, key) {
    let o = nextProps[key]
    let columnDefs = [
      {
        headerName: '',
        width: 30,
        field: 'rowIndex',
        hidden: true,
        suppressMovable: true,
        cellStyle: {
          textAlign: 'center',
          padding: '5px 0',
          color: '#595959',
          backgroundColor: '#f0f0f0',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: '500',
          boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
        },
      },
      {
        headerName: '姓名',
        field: 'fullName',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '账号',
        field: 'userName',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '任职',
        field: 'userIdentityInfo',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '答题次数',
        field: 'answerTimeCount',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '答错次数',
        field: 'answerErrorTimeCount',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '答错率',
        field: 'answerErrorRate',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
    ]
    if(o['success']){
      let data = o['data']
      WizBrowserExport({
        title: '错误人员分析',
        sheetName: '错误人员分析',
        columns: columnDefs.filter((_, index) => index),
        rows: data,
        filename: '错误人员分析.xlsx'
      })
      return true
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _render() {
    const {examRecordLoading} = this.props;
    let initialValue = this.initialValue;
    console.log("initialValue==",initialValue);
    const {id,examId,examName,examDate} = initialValue;
    let _templateConfig = templateConfig({
      examId: examId, 
      questionId : id,
      examName,
      examDate
    });
    let _reduxTemplateConfig = reduxTemplateConfig({
      examId: examId,
      questionId : id,
      templateConfig: _templateConfig,
      apiDataFormat: {
        exportAnswer: this._handleAnswerFile,
      },
    });

    let _templateConfigPerson = templateConfigPerson({
      examId: examId, 
      questionId : id,
    });
    let _reduxTemplateConfigPerson = reduxTemplateConfigPerson({
      examId: examId,
      questionId : id,
      templateConfig: _templateConfigPerson,
      apiDataFormat: {
        exportPerson: this._handlePersonFile,
      },
    });
   
    let record = {examName,examDate,questionId:id}
    
    return <>
        <ExamInfo record={record} />
        <WizCard title={'错题分析'}>
        <WizTabs defaultActiveKey="1" animated={false} onChange={this.changeTab}>
            <TabPane tab="错误答案分析" key="1">
                <WizReduxTemplate {..._reduxTemplateConfig} />
            </TabPane>
            <TabPane tab="错误人员分析" key="2">
                <WizReduxTemplate {..._reduxTemplateConfigPerson} />
            </TabPane>
          </WizTabs>
        </WizCard>

      </>
  }
}

const mapStateToProps = (state, ownProps) => {
  const {examRecord } = state;
  const load = modelUtils.getLoadingState(state, ['examRecord']);
  return {
    ...load
  }
};

export default connect(mapStateToProps)(ErrorQuestionAnalysisList);
